<nav class="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
  <div class="navbar-brand-wrapper d-flex align-items-center justify-content-center">
    <a class="navbar-brand brand-logo mt-2" routerLink="/"><img class="main-logo-img" src="assets/images/logo-mini.png"
        alt="logo" /></a>
    <a class="navbar-brand brand-logo-mini" routerLink="/"><img src="assets/images/logo-mini.png" alt="logo" /></a>
  </div>
  <div class="navbar-menu-wrapper d-flex align-items-stretch">
    <button class="navbar-toggler navbar-toggler align-self-center pr-0" type="button" data-toggle="minimize"
      (click)="toggleSidebar()">
      <span class="mdi mdi-menu"></span>
    </button>
    <!-- <ul class="navbar-nav">
      <li class="nav-item  dropdown d-none d-md-block" ngbDropdown>
        <a class="nav-link nav-btn" id="reportDropdown" ngbDropdownToggle translate>
          <span class="btn">+ Create new</span>
        </a>
        <div class="dropdown-menu navbar-dropdown" ngbDropdownMenu aria-labelledby="reportDropdown">
          <a class="dropdown-item" href="javascript:;">
            <i class="icon-user text-primary"></i><span translate>User Account</span>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:;">
            <i class="icon-user-following text-warning"></i><span translate>Admin User</span>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:;">
            <i class="icon-docs text-success"></i><span translate>Sales report</span>
          </a>
        </div>
      </li>
    </ul> -->
    <ul class="navbar-nav navbar-nav-right">
      <li class="nav-item dropdown d-lg-flex" ngbDropdown>
        <a class="nav-link dropdown-toggle" ngbDropdownToggle id="languageDropdown" href="javascript:(void)">
          <i class="flag-icon flag-icon-gb"></i>
          {{(lang==='ar'?'arabicLanguage' : 'englishLanguage') | translate}}
        </a>
        <div class="dropdown-menu navbar-dropdown" ngbDropdownMenu aria-labelledby="languageDropdown">
          <a class="dropdown-item font-weight-medium" href="javascript:(void)" (click)="changeLanguage()">
            <i class="flag-icon flag-icon-ae"></i>
            {{(lang==='ar'?'englishLanguage' : 'arabicLanguage') | translate}}
          </a>
        </div>
      </li>
      <li class="nav-item dropdown" ngbDropdown>
        <a class="nav-link count-indicator dropdown-toggle" ngbDropdownToggle id="notificationDropdown"
          href="javascript:;" data-toggle="dropdown" (click)="getTopMyNotifications()">
          <i class="icon-bell mx-0"></i>
          <span *ngIf="showHasNotification" class="count notification-count-icon"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-left navbar-dropdown preview-list" ngbDropdownMenu
          id="notifications-panel" aria-labelledby="notificationDropdown"
          [ngClass]="{'notifications-panel-r' : lang==='ar','notifications-panel-l' : lang !=='ar' }">
          <a class="dropdown-item">
            <p *ngIf="notificationsCount>0" class="mb-0 font-weight-normal float-left">{{'youHave' | translate}}
              {{notificationsCount}} {{'notifications' | translate}}
            </p>
            <span class="badge badge-pill background-main-color view-all-btn float-right mr-2 ml-2"
              (click)="goToNotifications()">{{'viewAll' |
              translate}}</span>
          </a>
          <div class="dropdown-divider"></div>
          <div class="text-center pl-4 pr-4"
            *ngIf="!myNotifications || myNotifications===null || myNotifications.length===0">
            <span>{{'noNewNotifications' | translate}}</span>
          </div>
          <div style="height: 500px;overflow-y: auto;">
            <a class="dropdown-item preview-item" *ngFor="let notification of myNotifications"
              (click)="goToRoute(notification)">
              <div class="preview-thumbnail">
                <div class="preview-icon"
                  [ngClass]="{'not-read-notification' : notification.status!==1,'background-main-color' : notification.status ===1 }">
                  <i class=" icon-bell mx-0"></i>
                </div>
              </div>
              <div class="preview-item-content">
                <h6 class="preview-subject font-weight-medium">{{notification.type | translate}}</h6>
                <p class="font-weight-light small-text">
                  {{notification.body}}
                </p>
              </div>

              <div class="dropdown-divider"></div>
            </a>
          </div>


        </div>
      </li>
      <li class="nav-item nav-settings d-lg-flex" (click)="logout()">
        <a class="nav-link p-0 w-100 ml-1 mr-1" href="javascript:;">
          <i class="icon-logout"></i>
        </a>
      </li>

      <!-- <li class="nav-item dropdown" ngbDropdown>
        <a class="nav-link count-indicator dropdown-toggle" ngbDropdownToggle id="messageDropdown" href="javascript:;"
          data-toggle="dropdown" aria-expanded="false">
          <i class="icon-envelope mx-0"></i>
          <span class="count"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" ngbDropdownMenu
          aria-labelledby="messageDropdown">
          <div class="dropdown-item">
            <p class="mb-0 font-weight-normal float-left">You have 7 unread mails
            </p>
            <span class="badge badge-info badge-pill float-right">View all</span>
          </div>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item preview-item">
            <div class="preview-thumbnail">
              <img src="https://via.placeholder.com/86x86" alt="image" class="profile-pic">
            </div>
            <div class="preview-item-content flex-grow">
              <h6 class="preview-subject ellipsis font-weight-medium">David Grey
                <span class="float-right font-weight-light small-text">1 Minutes ago</span>
              </h6>
              <p class="font-weight-light small-text">
                The meeting is cancelled
              </p>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item preview-item">
            <div class="preview-thumbnail">
              <img src="https://via.placeholder.com/86x86" alt="image" class="profile-pic">
            </div>
            <div class="preview-item-content flex-grow">
              <h6 class="preview-subject ellipsis font-weight-medium">Tim Cook
                <span class="float-right font-weight-light small-text">15 Minutes ago</span>
              </h6>
              <p class="font-weight-light small-text">
                New product launch
              </p>
            </div>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item preview-item">
            <div class="preview-thumbnail">
              <img src="https://via.placeholder.com/86x86" alt="image" class="profile-pic">
            </div>
            <div class="preview-item-content flex-grow">
              <h6 class="preview-subject ellipsis font-weight-medium"> Johnson
                <span class="float-right font-weight-light small-text">18 Minutes ago</span>
              </h6>
              <p class="font-weight-light small-text">
                Upcoming board meeting
              </p>
            </div>
          </a>
        </div>
      </li>-->
      <!-- <li class="nav-item nav-settings d-none d-lg-flex" (click)="toggleRightSidebar()">
        <a class="nav-link p-0 w-100" href="javascript:;">
          <i class="icon-grid"></i>
        </a>
      </li> -->
    </ul>
    <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
      (click)="toggleOffcanvas()">
      <span class="mdi mdi-menu"></span>
    </button>
  </div>
</nav>


<button id="refreshUserNotificationsBtn" style="display: none;" (click)="getMyNotificationsCount()"></button>
